import React, { useEffect, useState } from "react"
import { Spinner } from "@trimbleinc/modus-react-bootstrap"
import { useAppContext } from "../contexts/AppContext"
import TaskTreeComponent from "./TaskTreeComponent"
import { TaskTypeDefinitionsCache } from "../apis/TaskTypeDefinitionsCache"
import PublishedTaskList from "./PublishedTaskList"

const FolderTree = () => {
  const { projectID, accessToken, projectLocation, API } = useAppContext()
  const [loading, setLoading] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState<string>("Presentations")

  useEffect(() => {
    const initializeTaskTypeDefinition = async () => {
      await TaskTypeDefinitionsCache.getInstance().init(accessToken, projectLocation)
    }

    if (projectLocation) {
      initializeTaskTypeDefinition()
    }
  }, [projectID, accessToken, projectLocation])

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCategory(event.target.value)
  }

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div className="tab-panel-topbar">
        <div className="tab-title-section">
          <span className="tab-main-heading">Shared Object Model</span>
          <div className="dropdown-pane-container">
            <select value={selectedCategory} onChange={handleSelectChange} className="custom-select">
              <option value="" disabled>
                Select a category
              </option>
              <option value="Presentations">Published Presentations</option>
              {/* <option value="TaskModel">TaskModel</option> */}
            </select>
          </div>
        </div>
      </div>
      <div className="panel-content">
        <div className="panel-items" style={{ overflowY: "auto", width: "100%", height: "calc(100% - 100px)" }}>
          {selectedCategory === "TaskModel" ? (
            <TaskTreeComponent />
          ) : loading ? (
            <div className="px-3">
              <div className="text-center">
                <Spinner animation="border" variant="primary" role="status" />
                <div className="h3 text-primary mt-3">Loading...</div>
              </div>
            </div>
          ) : (
            <PublishedTaskList />
          )}
        </div>
      </div>
    </div>
  )
}

export default FolderTree
